import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ModalService } from '../../services/services';
import { Subject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-modal-adapter',
  template: '',
})
export class ModalAdapter implements OnInit {
  readonly modalService = inject(ModalService);
  readonly _props = inject(DIALOG_DATA);

  props$ = new Subject<any>();
  props = toSignal(this.props$);

  ngOnInit(): void {
    this.props$.next(this._props);
  }

  close() {
    this.modalService.close();
  }
}
